<script setup>
  import { ICON_SUBMENU } from '@/config/menus/nav-drawer-menu-items';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

  const props = defineProps({
    iconName: String,
    iconType: {
      type: String,
      default: 'solid',
      validator: (value) => ['solid', 'regular', 'brand'].includes(value),
    },
    level: {
      type: Number,
      default: 1,
    },
  });
  const iconClass = `fa-${props.iconType} fa-${props.iconName}`;
  const iconSize = props.level > 1 && props.iconName == ICON_SUBMENU ? 'sm' : 'lg';
</script>

<template>
  <!-- `fixed-width` uses the whole Icon Canvas, so the text next to icon will be left-aligned
       https://docs.fontawesome.com/web/style/icon-canvas
  -->
  <font-awesome-icon :icon="iconClass" :size="iconSize" fixed-width />
</template>
